import { render } from "./footer.vue?vue&type=template&id=9f6151da&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=9f6151da&lang=scss&scoped=true"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f6151da"]])

export default __exports__